import { Column, Icon, Row, Text } from "@bunnix/components";
import useDevice from "./hooks/useDevice.mjs";

const IOS_STEPS = [
  {
    icon: "square_arrow_up",
    title: "Toque em Compartilhar",
    detail: "Na barra do Safari, toque no ícone de compartilhamento (quadrado com seta para cima).",
  },
  {
    icon: "plus_app",
    title: "Adicionar à Tela de Início",
    detail: "Role a lista de ações e toque em Adicionar à Tela de Início.",
  },
  {
    icon: "checkmark",
    title: "Confirme",
    detail: "Toque em Adicionar, no canto superior, para concluir.",
  },
];

const ANDROID_STEPS = [
  {
    icon: "ellipsis",
    title: "Abra o menu do Chrome",
    detail: "Toque nos três pontos, no canto superior direito do navegador.",
  },
  {
    icon: "plus_app",
    title: "Adicionar à tela inicial",
    detail: "Toque em Adicionar à tela inicial ou em Instalar aplicativo.",
  },
  {
    icon: "checkmark",
    title: "Confirme",
    detail: "Confirme em Instalar ou Adicionar para concluir.",
  },
];

const DESKTOP_STEPS = [
  {
    icon: "ellipsis",
    title: "Abra o menu do navegador",
    detail: "No Chrome ou Edge, clique no menu ou no ícone de instalação da barra de endereço.",
  },
  {
    icon: "plus_app",
    title: "Instale o SemViés",
    detail: "Escolha a opção Instalar SemViés… na lista.",
  },
  {
    icon: "checkmark",
    title: "Confirme",
    detail: "Clique em Instalar na janela de confirmação para concluir.",
  },
];

function Step({ index, icon, title, detail }) {
  return Row(
    { gap: 12, alignItems: "start" },
    Text({ fontSize: "x-large", fontShadow: "orange", fontWeight: 800 }, `${index}`),
    Column(
      { gap: 4 },
      Row(
        { gap: 8, alignItems: "center" },
        ...(icon ? [Icon({ name: icon, size: 20 })] : []),
        Text({ fontWeight: 600 }, title),
      ),
      Text({ dimmed: true }, detail),
    ),
  );
}

export default function InstallInstructionsPage() {
  const { isIos, isAndroid, isStandalone } = useDevice();

  if (isStandalone) {
    return Column(
      { bg: "accent", padding: "regular", fontColor: "primary-on-accent", gap: 12 },
      Text(
        { fontSize: "x-large", fontAdjust: "large-title", fontWeight: 600 },
        "Tudo pronto!",
      ),
      Text(
        { fontSize: "large" },
        "O SemViés já está instalado na tela de início deste dispositivo.",
      ),
    );
  }

  const steps = isIos ? IOS_STEPS : isAndroid ? ANDROID_STEPS : DESKTOP_STEPS;
  const subtitle = isIos
    ? "No iPhone ou iPad (Safari)"
    : isAndroid
      ? "No Android (Chrome)"
      : "No computador";

  return Column(
    { bg: "accent", padding: "regular", fontColor: "primary-on-accent", gap: 24 },
    Column(
      { gap: 8 },
      Text(
        { fontSize: "x-large", fontAdjust: "large-title", fontDesign: "mono", fontWeight: 600 },
        "Adicione o SemViés à tela de início :)",
      ),
      Text({ fontSize: "large", fontWeight: 600 }, subtitle),
    ),
    Column(
      { gap: 16 },
      ...steps.map((step, i) => Step({ index: i + 1, ...step })),
    ),
  );
}
